/** @jsx jsx */
import { jsx } from '@emotion/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@airwallex/form-select';
import { components } from 'react-select';
import { IconGlobe } from '@airwallex/glyphs';
import { LanguageMapping, LangKey, NativeLanguageNames } from '@/utils/types/langKey';
import { setLangToLocalStorage } from '@/utils/localstorage';
import { grays } from '@airwallex/colors';

const Control = (
  { children, ...rest }: any // eslint-disable-line @typescript-eslint/no-explicit-any
) => (
  <components.Control {...rest}>
    <IconGlobe height={12} width={12} color={grays[60]} />
    {children}
  </components.Control>
);

export const LanguageSelect: FC = () => {
  const { i18n } = useTranslation();
  const LANGUAGE_OPTIONS = Object.keys(LanguageMapping).map((val) => ({
    value: val,
    label: NativeLanguageNames[val as LangKey],
  }));
  const selectValue = LANGUAGE_OPTIONS.find((option) => option.value === i18n.language);

  return (
    <Select
      name="language"
      menuPlacement="top"
      options={LANGUAGE_OPTIONS}
      isSearchable={false}
      components={{
        Control,
      }}
      styles={{
        control: (base) => ({
          ...base,
          border: 'none',
          outline: 'none',
          background: 'transparent',
          '&:hover': {
            background: 'transparent',
          },
        }),
        valueContainer: (base) => ({
          ...base,
          padding: 0,
          marginLeft: 4,
          width: 48,
        }),
        singleValue: (base) => ({
          ...base,
          color: grays[60],
          fontSize: 12,
          lineHeight: '18px',
        }),
        menu: (baseStyles) => ({
          ...baseStyles,
          zIndex: 9999,
        }),
      }}
      onChange={(option: any) => {
        if (option?.value) {
          i18n.changeLanguage(option.value);
          setLangToLocalStorage(option.value);
        }
      }}
      value={selectValue}
    />
  );
};

export default LanguageSelect;
